export default "__VITE_ASSET__Dxd1f8WU__"